/** Refraction distance in the same 1920px reference space as frame geometry.
 * Only the outer half is bevelled; the inner half stays perfectly flat.
 * Maximum displacement is 3x the previous 64px profile. */
export const FRAME_REFRACTION_DISTANCE = 192;
// Phase is measured from the OUTSIDE (0) towards the content (1).
export const FRAME_REFRACTION_FLAT_START = .5;
// Circular arc, stopped just short of its vertical tangent to stay finite.
// Unlike smoothstep, displacement keeps accelerating all the way to the rim.
const ARC_EXTENT = .98;
const ARC_MAX = ARC_EXTENT*ARC_EXTENT/(1+Math.sqrt(1-ARC_EXTENT*ARC_EXTENT));

export function frameRefractionOffset(phase:number,strength:number,scale=1):number {
  const progress=1-Math.max(0,Math.min(1,phase/FRAME_REFRACTION_FLAT_START));
  const x=progress*ARC_EXTENT;
  // Rationalized 1-sqrt(1-x²) avoids cancellation at the flat-to-arc join.
  const bevel=(x*x/(1+Math.sqrt(1-x*x)))/ARC_MAX;
  return Math.max(0,Math.min(100,strength))/100*FRAME_REFRACTION_DISTANCE*Math.max(0,scale)*bevel;
}

// Shared profile constants prevent the renderer and mathematical checks drifting.
export const FRAME_REFRACTION_GLSL=`float outerBevel(float phase){
 float progress=1.-clamp(phase/${FRAME_REFRACTION_FLAT_START.toFixed(10)},0.,1.);
 float x=progress*${ARC_EXTENT.toFixed(10)};
 return (x*x/(1.+sqrt(max(0.,1.-x*x))))/${ARC_MAX.toFixed(12)};
}`;
